import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';

import { NrDirectivesCommonModule } from 'nr-common';

import { NrMultiSelectComponent } from './nr-multiselect/nrmultiselect.component';
import { NrMultiSelectAllComponent } from './nr-multiselect/nrmultiselectall.component';
import { NrDropdownComponent } from './nr-dropdown/nrdropdown.component';
import { NrTripExistsValidatorDirective } from './validators/nr-trip-exists/nr-trip-exists.directive';
import { NrFloatComponent } from './nr-float/nrfloat.component';
import { NrMinValueDirective } from './validators/nr-min-value/nr-min-value.directive';
import { NrEmailDirective } from './validators/nr-email/nr-email.directive';
import { NrMaxValueDirective } from './validators/nr-max-value/nr-max-value.directive';
import { TableSourceSortDirective } from './nr-table/table-source-sort.directive';
import { RtfmService } from './nr-rtfm/rtfm.service';
import { SanitizerUrlPipe } from './pipes/sanitize-url.pipe';
import { FileSizePipe } from './pipes/file-size-pipe';
import { TagSelectorModule } from './tag-selector/tag-selector.module';
import { GoogleStaticMapComponent } from './google-static-map/google-static-map.component';
import { VerticalMenuModule } from './vertical-menu/vertical-menu.module';

export { DateTimeUtilities } from './utilities/date-time-utilities';
export { StringUtilities } from './utilities/string-utilities';
export { TypedFormGroup } from './utilities/typedFormGroup.type';
export { HandleMissingLabel } from './utilities/handleMissingLabel';

const KENDO = [
	LabelModule,
	InputsModule,
	TextBoxModule,
	DropDownsModule
];

@NgModule({
	declarations: [
    	GoogleStaticMapComponent,
		TableSourceSortDirective,
		NrMultiSelectComponent,
		NrMultiSelectAllComponent,
		NrDropdownComponent,
		NrTripExistsValidatorDirective,
		NrMinValueDirective,
		NrMaxValueDirective,
		NrFloatComponent,
		NrEmailDirective,
		SanitizerUrlPipe,
		FileSizePipe,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NgbTooltipModule,
		TranslateModule,
		TagSelectorModule,
		VerticalMenuModule,
		...KENDO
	],
	exports: [
    	GoogleStaticMapComponent,
		TableSourceSortDirective,
		NrMultiSelectComponent,
		NrMultiSelectAllComponent,
		NrDropdownComponent,
		NrTripExistsValidatorDirective,
		NrMinValueDirective,
		NrMaxValueDirective,
		NrFloatComponent,
		NgbTooltipModule,
		NrEmailDirective,
		SanitizerUrlPipe,
		NrDirectivesCommonModule,
		TagSelectorModule,
		FileSizePipe,
		VerticalMenuModule,
		...KENDO
	],
	providers: [RtfmService],
})
export class NrCommonModule {}
